import { activeRegistration, assignmentKey, registrationInView, rosterSquads, rosterValue, rosterWithdrawn } from "./directorRosterModel";

export function overviewRoster(match, rows, participants) {
  const squads = rosterSquads(match);
  const active = rows.filter(activeRegistration);
  const assignment = row => match.family === "arc" ? assignmentKey(row, squads) : String(rosterValue(row, "relayLabel"));
  const groups = match.family === "arc" ? squads : [...new Set(active.map(assignment).filter(Boolean))].sort().map(label => ({ key: label, label, capacity: null }));
  return {
    total: rows.length,
    pending: rows.filter(row => registrationInView(row, "pending", participants)).length,
    confirmed: rows.filter(row => registrationInView(row, "confirmed", participants)).length,
    unassigned: active.filter(row => !assignment(row)).length,
    removed: match.family === "arc" ? active.filter(row => assignment(row) && !squads.some(squad => squad.key === assignment(row))).length : 0,
    missingPoints: match.family === "bullseye" ? active.filter(row => !String(rosterValue(row, "firingPointLabel")).trim()).length : 0,
    heldWithdrawals: active.filter(row => rosterWithdrawn(row, participants)).length,
    groups: groups.map(group => {
      const members = active.filter(row => assignment(row) === group.key);
      return { ...group, count: members.length, confirmed: members.filter(row => row.status === "confirmed").length, pending: members.filter(row => row.status === "pending").length };
    }),
  };
}
